import { getTimezoneOffset } from "date-fns-tz";
import { useEffect, useMemo, useState } from "react";
import { pluralize } from "../../utils";

const BASE_DATE_OBJECT = { d: 0, h: 0, m: 0, s: 0 };

export const Countdown = ({ countdownUntil, style }) => {
  const dateWithBSTRemoved = useMemo(() => getAdjustedDateForBST(new Date(countdownUntil)), [countdownUntil]);

  const [remainingTime, setRemainingTime] = useState(BASE_DATE_OBJECT);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const end = dateWithBSTRemoved;
      const dif = (end - now) / 1000;

      if (dif > 0) {
        return {
          d: Math.floor(dif / (60 * 60 * 24)),
          h: Math.floor((dif / (60 * 60)) % 24),
          m: Math.floor((dif / 60) % 60),
          s: Math.floor(dif % 60),
        };
      }
      return BASE_DATE_OBJECT;
    };

    // Run on first load
    setRemainingTime(calculateTimeLeft());

    // Then each second afterwards
    const timer = setInterval(() => {
      setRemainingTime(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [dateWithBSTRemoved]);

  const { d, h, m, s } = remainingTime;

  return (
    <div className="d-flex flex-row" style={{ gap: "8px", ...style }}>
      <CountdownSection timeLeft={d} timeUnit="Day" />
      <CountdownSection timeLeft={h} timeUnit="Hour" />
      <CountdownSection timeLeft={m} timeUnit="Minute" />
      <CountdownSection timeLeft={s} timeUnit="Second" />
    </div>
  );
};

const CountdownSection = ({ timeLeft, timeUnit }) => (
  <div className="px-0 text-center">
    <strong style={{ fontSize: "18px" }}>{timeLeft}</strong>
    <p className="mb-0" style={{ fontSize: "12px" }}>
      {pluralize(timeUnit, timeLeft)}
    </p>
  </div>
);

export const getAdjustedDateForBST = (inputDate) => {
  const offset = getTimezoneOffset("Europe/London");

  return new Date(inputDate.getTime() - offset);
};
